import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ConfirmationModal } from '../../__legacy__/components/ConfirmationModal';
import { IAuthStore } from '../../__legacy__/modules/auth/auth.store';
import { IUserStore, Plan } from '../../__legacy__/modules/user/user.store';

export const PlanUpgradeModal = observer((): ReactElement => {
  const authStore = useInjection(IAuthStore.$);
  const userStore = useInjection(IUserStore.$);
  const t = useTranslator().t;

  const {
    userInfo: { id },
    planInfo: { plan, dataRetentionDate },
  } = userStore;

  const handleClose = (): void => {
    authStore.setShowPlanModal(false);
  };

  const handleConfirm = async (): Promise<void> => {
    authStore.setShowPlanModal(false);
    window.open('mailto:acdl-support@zebra.com', '_self');
    await Promise.resolve();
  };

  const date = dataRetentionDate ? new Intl.DateTimeFormat('en-us', { dateStyle: 'long' }).format(new Date(dataRetentionDate)) : '';

  const body = plan === Plan.Free ? 'plan_upgrade.description_free' : <div>{t('plan_upgrade.description_inactive', { dataRetentionDate: date })}</div>;

  const header = plan === Plan.Free ? 'plan_upgrade.title_free' : 'plan_upgrade.title_inactive';

  return (
    <ConfirmationModal
      showModal={authStore.showPlanModal && !!id && (plan === Plan.Free || plan === Plan.Inactive)}
      confirmationHeader={header}
      confirmationQuestion={body}
      onConfirm={handleConfirm}
      onCancel={handleClose}
      confirmationNo='close'
      confirmationYes='plan_upgrade.contact_sales'
    />
  );
});
